import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Pair role/rate settings live here; include=versions provides history. Neither relationship has a reciprocal inverse.
const PcsMerchantNetworkMerchantSettingSchema = withDefaults({
  type: 'pcs-merchant-network-merchant-setting',
  fields: [
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsMerchantNetworkMerchant',
      type: 'pcs-merchant-network-merchant',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'versions',
      type: 'setting-version',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsMerchantNetworkMerchantSettingSchema;
